<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="700">
      <v-card>
        <v-card-title class="text-h6 blue darken-2 white--text py-1"> Contrato CCA Cursos </v-card-title>

        <v-card-text class="pa-0">
          <iframe ref="myIframe" style="width: 100%; height: 600px"></iframe>
        </v-card-text>

        <v-card-actions class="py-0">
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="primary" text @click="dialog = false" class="ma-0"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
import { materias } from './programa-contrato-cca-cursos';

  export default {
    data() {
      return {
        loading: false,
        dialog: false,
        thiz: {},
        dataz: {},
      };
    },
    methods: {
      async setData(d, prog, thizz) {
        window.console.log('ccccaaa', d, prog, thizz);
        this.dialog = true;
        setTimeout(() => {
          this.$refs.myIframe.src = 'about:blank';
          if (prog.id == 7926) {
            this.getcontrato1(d, prog);
          } else {
            this.getcontrato2(d, prog);
          }
        }, 200);
      },
      async getcontrato1(d, prog) {
        this.loading = true;
        const es = d.estudiante;
        if (!es.seg_apellido) es.seg_apellido = '';
        const estudiante = `${es.nombres} ${es.pri_apellido} ${es.seg_apellido}`.trim();

        const writtenNumber = require('written-number');

        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${d.id}/plan-pago`;
        const pags = await xaxios
          .get(url)
          .then(({ data }) => data)
          .catch((error) => error);
        let monto_mensualidades = 0;
        let cuota_mensual = 0;
        let certificacion = 0;
        let monto_mensualidades_str = '';
        let cuota_mensual_str = '';
        let certificacion_str = '';
        if (pags && pags.data) {
          const pagos = pags.data;
          const mensuales = pagos.filter((p) => p.concepto_pago_id == 8);
          const certis = pagos.filter((p) => p.concepto_pago_id == 3);
          mensuales.forEach((m) => {
            monto_mensualidades += parseFloat(m.total);
          });
          certis.forEach((c) => {
            certificacion += parseFloat(c.total);
          });
          cuota_mensual = monto_mensualidades / mensuales.length;
          window.console.log('pagos', pagos);

          monto_mensualidades_str = writtenNumber(monto_mensualidades, { lang: 'es' }) + ' bolivianos';
          cuota_mensual_str = writtenNumber(cuota_mensual, { lang: 'es' }) + ' bolivianos';
          certificacion_str = writtenNumber(certificacion, { lang: 'es' }) + ' bolivianos';
        }

        let rector = 'Lic. Analí Katerin Villanueva Flores';
        if(prog.nombre_compuesto.includes('Carreras ')){
          rector = 'ING. PAULA MARIA DE LOS ANGELES MUÑOZ'
        }

        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const input = {
          programa: prog.nombre_compuesto,
          estudiante: estudiante,
          rector: rector,
          documento: es.num_doc,
          direccion: '' + es.domicilio,
          monto: `${monto_mensualidades}`,
          monto_str: monto_mensualidades_str,
          cuota_mensual: `${cuota_mensual}`,
          cuota_mensual_str: cuota_mensual_str,
          monto_certificacion: `${certificacion}`,
          monto_certificacion_str: certificacion_str,
          fecha_contrato: this.getfechaemit(),
          contenidos: [
            'Programa de Microsoft Windows',
            'Paquete de Microsoft Word',
            'Paquete de Microsoft Excel',
            'Paquete de Microsoft Power Point',
            'Paquete de Microsoft Publisher',
            'Paquete de Microsoft Access',
          ],
        };

        const graphql = JSON.stringify({
          query: 'mutation ($input: ContratoCursoCCA!) {\n  contrato_cca_cursos(input: $input)\n}',
          variables: { input },
        });
        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: graphql,
        };

        const res = await fetch(process.env.VUE_APP_CONTRATO, requestOptions)
          .then((response) => response.json())
          .then(({ data }) => data)
          .catch((error) => error);
        window.console.log('ressss', res);
        this.loading = false;
        if (res && res.contrato_cca_cursos) {
          const url = res.contrato_cca_cursos;
          this.$refs.myIframe.src = url;
        }
      },
      async getcontrato2(d, prog) {
        this.loading = true;
        const es = d.estudiante;
        if (!es.seg_apellido) es.seg_apellido = '';
        const estudiante = `${es.nombres} ${es.pri_apellido} ${es.seg_apellido}`.trim();

        const writtenNumber = require('written-number');

        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${d.id}/plan-pago`;
        const pags = await xaxios
          .get(url)
          .then(({ data }) => data)
          .catch((error) => error);
        let monto_mensualidades = 0;
        let cuota_mensual = 0;
        let certificacion = 0;
        let certificacion2 = 0;
        let monto_mensualidades_str = '';
        let cuota_mensual_str = '';
        let certificacion_str = '';
        let certificacion_str2 = '';
        if (pags && pags.data) {
          const pagos = pags.data;
          // window.console.log('pagossss', pagos);
          
          const mensuales = pagos.filter((p) => p.concepto_pago_id == 8);
          const certis = pagos.filter((p) => p.concepto_pago_id == 3 || p.concepto_pago_id == 334);
          const certis2 = pagos.filter((p) => p.concepto_pago_id == 335);
          mensuales.forEach((m) => {
            monto_mensualidades += parseFloat(m.total);
          });
          certis.forEach((c) => {
            certificacion += parseFloat(c.total);
          });
          certis2.forEach((c) => {
            certificacion2 += parseFloat(c.total);
          });
          cuota_mensual = monto_mensualidades / mensuales.length;
          window.console.log('pagos', pagos);

          monto_mensualidades_str = writtenNumber(monto_mensualidades, { lang: 'es' }) + ' bolivianos';
          cuota_mensual_str = writtenNumber(cuota_mensual, { lang: 'es' }) + ' bolivianos';
          certificacion_str = writtenNumber(certificacion, { lang: 'es' }) + ' bolivianos';
          certificacion_str2 = writtenNumber(certificacion2, { lang: 'es' }) + ' bolivianos';
        }

        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        let rector = 'Lic. Analí Katerin Villanueva Flores';
        if(prog.nombre_compuesto.includes('Carreras ')){
          rector = 'ING. PAULA MARIA DE LOS ANGELES MUÑOZ'
        }

        const {primer_anio,segundo_anio,tercer_anio,cuarto_anio} = materias(prog.id)

        const input = {
          programa_id: prog.id,
          programa: prog.nombre_compuesto,
          estudiante: estudiante,
          rector: rector,
          documento: es.num_doc,
          direccion: '' + es.domicilio,
          monto: `${monto_mensualidades.toFixed(0)}`,
          monto_str: monto_mensualidades_str,
          cuota_mensual: `${cuota_mensual.toFixed(0)}`,
          cuota_mensual_str: cuota_mensual_str,
          monto_certificacion: `${certificacion.toFixed(0)}`,
          monto_certificacion_str: certificacion_str,
          monto_certificacion2: `${certificacion2.toFixed(0)}`,
          monto_certificacion_str2: certificacion_str2,
          fecha_contrato: this.getfechaemit(),
          contenidos: [
            'Programa de Microsoft Windows',
            'Paquete de Microsoft Word',
            'Paquete de Microsoft Excel',
            'Paquete de Microsoft Power Point',
            'Paquete de Microsoft Publisher',
            'Paquete de Microsoft Access',
          ],
          primer_anio: primer_anio,
          segundo_anio: segundo_anio,
          tercer_anio: tercer_anio,
          cuarto_anio: cuarto_anio,
        };

        const graphql = JSON.stringify({
          query: 'mutation ($input: ContratoCarreraCCA!) {\n  contrato_cca_carreras(input: $input)\n}',
          variables: { input },
        });
        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: graphql,
        };

        const res = await fetch(process.env.VUE_APP_CONTRATO, requestOptions)
          .then((response) => response.json())
          .then(({ data }) => data)
          .catch((error) => error);
        window.console.log('ressss', res);
        this.loading = false;
        if (res && res.contrato_cca_carreras) {
          const url = res.contrato_cca_carreras;
          this.$refs.myIframe.src = url;
        }
      },
      getfechaemit() {
        const meses = [
          'enero',
          'febrero',
          'marzo',
          'abril',
          'mayo',
          'junio',
          'julio',
          'agosto',
          'septiembre',
          'octubre',
          'noviembre',
          'diciembre',
        ];

        const hoy = new Date();

        const fecha_emit =
          String(hoy.getDate()).padStart(2, '0') + ' dias de ' + meses[hoy.getMonth()] + ' de ' + hoy.getFullYear();
        return fecha_emit;
      },
    },
    mounted() {
      window.console.log('montado cca');
    },
  };
</script>
